import { Badge, Slider } from "antd";
import { BodyMap } from "../BodyMap/BodyMap";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { SORENESS_LEVELS } from "../../Utils/bodymap";
import { PAIN_LEVELS } from "../../Utils/bodymap";
import { useSelector } from "react-redux";

const question_key_to_levels = {
  bodymap_soreness: SORENESS_LEVELS,
  bodymap_joint_pain: PAIN_LEVELS,
};

export const BodyMapView = ({
  data = {},
  title = "",
  playersPage = false,
  question_key = "bodymap_soreness",
}) => {
  const [slider, setSlider] = useState(0);
  const { gender } = useSelector(({ team }) => team.info);

  const dates = useMemo(
    () => Object.keys(data || {}).sort((a, b) => (a < b ? -1 : 1)),
    [data]
  );

  const formatter = (value) => `${moment(dates[value]).format("YYYY-MM-DD")}`;

  const bodyMap = useMemo(() => {
    if (dates.length === 0) return {};
    const dateString = formatter(slider);
    return data[dateString];
  }, [slider, dates]);

  useEffect(() => {
    setSlider(0);
  }, [data]);

  const marks = useMemo(() => {
    if (dates.length === 0) return {};
    return dates.reduce((acc, curr, ind) => {
      acc[ind] = (
        <div style={{ fontSize: 12, fontWeight: "bold", whiteSpace: "nowrap" }}>
          {moment.utc(curr).format("M-D")}
        </div>
      );
      return acc;
    }, {});
  }, [dates]);

  return !data || dates.length === 0 ? (
    <></>
  ) : (
    <div style={{ width: "100%" }}>
      <p className="teamdata-graph-titles">{title}</p>
      {playersPage ? (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
            marginBottom: 24,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {question_key_to_levels[question_key].map((level, index) => (
            <div
              key={index}
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <div
                style={{
                  width: 12,
                  height: 12,
                  backgroundColor: level.color,
                  borderRadius: 6,
                }}
              />
              <span style={{ fontSize: 12 }}>{level.label}</span>
            </div>
          ))}
        </div>
      ) : null}

      <BodyMap playersPage={playersPage} data={bodyMap} gender={gender} />
      <div style={{ fontWeight: "bold", fontSize: 16 }}>{dates[slider]}</div>
      <Slider
        max={dates.length - 1}
        marks={marks}
        value={slider}
        onChange={setSlider}
        step={null}
        tooltip={{ formatter, placement: "left" }}
        style={{ marginTop: 24 }}
      />
    </div>
  );
};
